// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__H3lrQ","controls":"Pagination_controls__tRzeF","pageInfo":"Pagination_pageInfo__WKs9s","info":"Pagination_info__puYYp"};